{
  "it": {
    "integration": {
      "actions": {
        "goTo": "Vai a {name}"
      },
      "labels": {
        "apiTokensUsedByYou": "Token API",
        "create_failed": "Creazione non riuscita",
        "crm_id": "ID {integration_oid_type} in {integration_name}: {integration_oid}",
        "description": "Descrizione",
        "error": "errore",
        "integration": "Integrazione",
        "integrationOID": "ID integrazione",
        "last_sync_with": "Ultima sincronizzazione con {integration_name} ({last_sync_at})",
        "status": "stato",
        "synced_at": "Ultima sincronizzazione: ",
        "title": "Integrazioni gestite da Ziggu",
        "update_failed": "aggiornamento non riuscito"
      },
      "record_actions": {
        "delete": "Affinché {record_type} venga eliminato definitivamente su Ziggu (e non riappaia), {record_type} <strong>deve prima essere eliminato su {integration_name}</strong>."
      },
      "toasts": {
        "update": "Integrazione aggiornata"
      }
    }
  }
}
